var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"divergent-table-button",class:{'divergent-table-button-red': _vm.haveDivergent},on:{"click":_vm.action}},[_vm._v(_vm._s(!_vm.haveDivergent ? 'Incluir Divergência' : 'Editar Divergência'))])
}
var staticRenderFns = []

export { render, staticRenderFns }